import React from 'react';
import { Redirect } from 'react-router-dom';
import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { WarehousePermission } from '../../generated/graphql';
import { RouteType } from '../../types';
import { WarehouseIcon } from '../../ui-kit';
import { WarehouseScopeProvider } from '../../modules/warehouse/providers';
import { WarehouseListRoute } from './WarehouseList';
import { WarehouseCardsRoute } from './WarehouseCards';
import { WarehouseCategoriesRoute } from './WarehouseCategories';
import { InventoryCountRoute } from './InventoryCount';
import { DeliveryListsRoute } from './DeliveryLists';
import { DeductionListsRoute } from './DeductionLists';

const WarehouseRoute: RouteType = {
    exact: true,
    path: routePaths.warehouse,
    title: translate('Warehouse'),
    icon: WarehouseIcon,
    component: () => <Redirect to={routePaths.warehouses} />,
    permissions: {
        warehouse: [WarehousePermission.CanViewWarehouse],
    },
    scopeProvider: WarehouseScopeProvider,
    childrenRoutes: [
        WarehouseListRoute,
        WarehouseCardsRoute,
        WarehouseCategoriesRoute,
        InventoryCountRoute,
        DeliveryListsRoute,
        DeductionListsRoute,
    ],
};

export default WarehouseRoute;
